import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { referenceDataHubCards } from "../../navigation/appNavigation";

const ReferenceDataHubPage = () => (
    <SectionHubPage title="Reference Data" cards={referenceDataHubCards} />
);

export { ReferenceDataHubPage };
